import { notification } from 'antd'
import { useEffect } from 'react'

import { useNotifications } from '@store/notifications'

export const Notifications = () => {
    const { key, title, description, type, placement, duration } = useNotifications()

    const [api, contextHolder] = notification.useNotification()

    useEffect(() => {
        if (key) {
            api[type]({
                message: title,
                description,
                placement,
                duration
            })
        }
    }, [key])

    return <>{contextHolder}</>
}
